module.exports = __webpack_public_path__ + "static/assets/cddd23aef46b112f733604ab0098c70e.svg";